"use client";
import { createAnatomy } from "@zag-js/anatomy";
//#region src/components/field/field.anatomy.ts
var fieldAnatomy = createAnatomy("field").parts("root", "errorText", "helperText", "input", "label", "select", "textarea", "requiredIndicator");
var parts = fieldAnatomy.build();
//#endregion
export { fieldAnatomy, parts };
